export interface IArLine {
  description: string
  detail: string
  loanAmount: number | null
  rate: number | null
  amount: number
}

export interface IAccountsReceivable {
  id: number
  invoiceNo: string
  invoiceDate: string
  dueDate: string | null
  dueLabel: string
  billToName: string
  billToAddress: string
  billToEmail: string
  subjectProperty: string
  lines: IArLine[]
  amount: number
  paymentNote: string
  isPaid: boolean
  paidAt: string | null
  paidNotifyEmails: string
  reminderMode: 'global' | 'custom' | 'off'
  reminderDaysBefore: number[]
  reminderOverdueEvery: number
  reminderEmails: string
  lastReminderOn: string | null
  createdAt: string
}

export interface IAccountsReceivableSettings {
  invoicePrefix: string
  startingInvoiceNo: number
  nextInvoiceNo?: string
  remindersEnabled: boolean
  daysBefore: number[]
  overdueEveryDays: number
  reminderEmails: string
  notifyBillTo: boolean
  paidEmails: string
  notifyBillToOnPaid: boolean
  paymentNote: string
  suggestedPrefix: string
}

export const emptyLine = (): IArLine => ({
  description: '',
  detail: '',
  loanAmount: null,
  rate: null,
  amount: 0,
})
